import "./src/global.css";

import React from "react";
import ContextProvider from "./src/contexts/ContextProvider";
import { ADSENSE_SCRIPT_SRC, isAdRoute } from "./src/utils/adsense";
import { pageLang } from "./src/utils/locale";

export const wrapRootElement = ({ element }) => {
  return <ContextProvider>{element}</ContextProvider>;
};

/**
 * gatsby-ssr.js only puts the AdSense loader in the head of pages that were
 * server-rendered as ad routes. Someone who lands on /patterns and then clicks
 * through to the blog never gets it, because Gatsby navigates client-side and
 * never re-renders the document head.
 *
 * So: on every route change, if this is an ad route and the loader isn't on the
 * page yet, add it. The matcher is shared with gatsby-ssr.js.
 *
 * Note this only covers *loading* the script. Auto ads scans the DOM when the
 * script initialises and does not re-scan on later client-side navigations, so
 * auto ads still favour whichever ad route was entered first. Manually placed
 * <ins> units are not affected — they push on mount.
 */
export const onRouteUpdate = ({ location }) => {
  if (typeof document === "undefined") return;

  // gatsby-ssr sets <html lang> for the entry page only; client-side
  // navigation across locales has to keep it current.
  document.documentElement.lang = pageLang(location?.pathname ?? "");

  if (!isAdRoute(location?.pathname ?? "")) return;

  // Covers both the server-rendered tag and one we injected earlier.
  if (document.querySelector('script[src*="adsbygoogle.js"]')) return;

  const script = document.createElement("script");
  script.src = ADSENSE_SCRIPT_SRC;
  script.async = true;
  script.crossOrigin = "anonymous";
  document.head.appendChild(script);
};

export { wrapPageElement } from "./src/i18n/wrapPageElement";
